<footer class="footer-nav d-flex justify-content-around align-items-center py-2 px-1">
  <a *ngIf="permissionService.canView('DriverApp-Dashboard')" class="nav-item" routerLink="/dashboard" routerLinkActive="active" #rla="routerLinkActive">
    <div class="nav-icon">
      <div>
        <img *ngIf="!rla.isActive" src="assets/icons/dashboard-inactive.png" alt="icon" width="20" height="20">
      </div>
      <div>
        <img *ngIf="rla.isActive" src="assets/icons/dashboard-active.png" alt="icon" width="20" height="20">
      </div>
    </div>
    <div class="nav-label">Dashboard</div>
  </a>

  <a *ngIf="permissionService.canView('DriverAppAllOrder')" class="nav-item" routerLink="/my-orders" routerLinkActive="active" #drla="routerLinkActive">
    <div class="nav-icon">
      <div>
        <img *ngIf="!drla.isActive" src="assets/icons/parcel-inactive.png" alt="icon" width="20" height="20">
      </div>
      <div>
        <img *ngIf="drla.isActive" src="assets/icons/parcel-active.png" alt="icon" width="20" height="20">
      </div>
    </div>
    <div class="nav-label">All Orders</div>
  </a>

  <a *ngIf="permissionService.canView('DriverAppOrderReport')" class="nav-item" routerLink="/order-report" routerLinkActive="active" #orla="routerLinkActive">
    <div class="nav-icon">
      <div>
        <img *ngIf="!orla.isActive" src="assets/icons/report-inactive.png" alt="icon" width="20" height="20">
      </div>
      <div>
        <img *ngIf="orla.isActive" src="assets/icons/report-active.png" alt="icon" width="20" height="20">
      </div>
    </div>
    <div class="nav-label">Order Report</div>
  </a>

  <!-- <a class="nav-item" routerLink="/delivery" routerLinkActive="active" #delvrla="routerLinkActive">
    <div class="nav-icon">
      <div>
        <i *ngIf="!delvrla.isActive" class="bi bi-truck text-black"></i>
      </div>
      <div>
        <i *ngIf="delvrla.isActive" class="bi bi-truck text-success"></i>
      </div>
    </div>
    <div class="nav-label">Delivery</div>
  </a> -->
</footer>